import React from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { BreadcrumbContainer } from './Breadcrumb.styled';
import DynamicBreadcrumbs from '../../../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs';

const Breadcrumb = ({ agentNameFromParent = '' }) => {
    const { pathname } = useLocation();

    const items = [
        { label: 'Agents', href: '/v2/agentsView' },
    ];


    return (
        <BreadcrumbContainer>
            <DynamicBreadcrumbs items={items} currentPath={pathname} />
        </BreadcrumbContainer>
    );
};

export default Breadcrumb;
